import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

const ComplaintsView = () => {
  const { id } = useParams(); // Get the id from the URL
  const navigate = useNavigate();
  const [complaint, setComplaint] = useState(null);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL + "complaints/";

  useEffect(() => {
    const fetchComplaintDetails = async () => {
      setLoader(true);
      setError(null);
      try {
        const token = localStorage.getItem('jwttoken');
        const response = await axios.get(`${API_BASE_URL}getcomplaint/${id}`,{
          headers: {
            'x-access-token': token
          }
        });
        setComplaint(response.data[0]);
      } catch (error) {
        console.error("Error:", error);
        setError(error.response?.data?.message || "Failed to fetch complaint details.");
      } finally {
        setLoader(false);
      }
    };

    fetchComplaintDetails();
  }, [id]);

  if (loader) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="text-center">
        Error: {error}
      </Alert>
    );
  }

  if (!complaint) {
    return (
      <Alert variant="warning" className="text-center">
        No complaint found.
      </Alert>
    );
  }

  return (
    <div className="container mt-5">
      <Card className="shadow-lg">
        <Card.Header as="h5" className="bg-primary text-white">
          Complaint Details
        </Card.Header>
        <Card.Body>
          <p><strong>User ID:</strong> {complaint.user_id}</p>
          <p><strong>Name:</strong> {complaint.name}</p>
          <p><strong>Contact:</strong> {complaint.mobile}</p>
          <p><strong>Email:</strong> {complaint.email}</p>
          <p><strong>Subject:</strong> {complaint.subject}</p>
          <p><strong>Message:</strong> {complaint.message}</p>
          <p><strong>Status:</strong> {complaint.status}</p>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ComplaintsView;